<template>
    <Form>
        <h2>Log in to your account</h2>

        <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-alert v-if="info" color="blue" outlined text v-html="info" />
            <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
                {{ error }}
            </v-alert>
            <v-alert v-else-if="message" color="green" outlined text>
                <v-progress-circular indeterminate color="green" />
                {{ message }}
            </v-alert>

            <div class="font-weight-medium">Email</div>
            <v-text-field outlined dense type="email" v-model="form.Email" name="email" :readonly="emailReadOnly" />

            <div class="font-weight-medium">Password</div>
            <v-text-field outlined dense type="password" v-model="form.Password" name="password" />

            <router-link :to="{ name: 'auth/reset', params: { email: this.form.Email } }">Forgot password?</router-link>

            <v-btn block type="submit" :disabled="!valid || loadingGoogle" :loading="loading" class="blue-btn mt-5">Log In</v-btn>
        </v-form>

        <div class="my-5 text-center">or</div>

        <v-btn block @click="google" outlined>
            <img src="/static/img/google.svg" height="20" alt="google icon" style="position: absolute; left: 0" />
            Log in with Google
            <v-progress-circular v-if="loadingGoogle" indeterminate size="20" color="green" class="ml-2" />
        </v-btn>

        <div class="pt-12 caption text-center">
            If you have Single Sign-On (SSO) enabled on your account, please sign in using your authentication provider, or reach out to
            support@coroot.com for further assistance.
        </div>

        <div class="pa-12">
            <p class="text-center">
                Don't have an account?
                <router-link :to="{ name: 'signup', query: $route.query }" class="text-no-wrap">Sign Up.</router-link>
            </p>
        </div>
    </Form>
</template>

<script>
import Form from '@/pages/Form';

export default {
    components: { Form },
    data() {
        return {
            form: {
                Email: '',
                Password: '',
                Invite: '',
            },
            valid: false,
            error: '',
            message: '',
            info: '',
            loading: false,
            emailReadOnly: false,
            loadingGoogle: false,
        };
    },

    mounted() {
        if (this.$route.query.invite) {
            const token = this.$route.query.invite || '';
            this.form.Invite = token;
            const info = this.$api.jwtDecode(token);
            this.form.Email = info.e;
            this.emailReadOnly = true;
            this.info = `Log in to join the <b>${info.wn}</b> workspace`;
        }
        if (this.$route.query.google) {
            const req = {
                Action: 'login',
                RedirectURL: window.location.origin + this.$router.resolve({ name: 'auth/google' }).route.path,
                AuthCode: this.$route.query.google,
                Invite: this.$route.query.invite || '',
            };
            this.$router.replace({ query: { ...this.$route.query, google: undefined } });
            this.loadingGoogle = true;
            this.$api.authGoogle(req, (data, meta) => {
                this.loadingGoogle = false;
                if (!meta.error) {
                    this.redirect();
                    return;
                }
                if (meta.code === 404) {
                    this.error = 'We did not find any accounts matching your login credentials.';
                    return;
                }
                this.error = meta.error;
            });
        }
    },

    methods: {
        redirect() {
            this.$router.push(this.$route.query.next || { name: 'console' });
        },
        submit() {
            this.loading = true;
            this.$api.login(this.form, (data, meta) => {
                this.loading = false;
                if (meta.code < 400) {
                    this.redirect();
                    return;
                }
                if (meta.code === 401) {
                    this.error = 'Incorrect email or password.';
                    return;
                }
                if (meta.code === 405 && meta.error === 'google') {
                    this.message = 'Google authenticated account found, redirecting...';
                    setTimeout(() => {
                        this.emailReadOnly = true;
                        this.google();
                    }, 3000);
                    return;
                }
                this.error = meta.error;
            });
        },
        google() {
            const req = {
                State: JSON.stringify({ action: this.$route.name, params: this.$route.query }),
                RedirectURL: window.location.origin + this.$router.resolve({ name: 'auth/google' }).route.path,
                LoginHint: this.emailReadOnly ? this.form.Email : '',
            };
            this.loadingGoogle = true;
            this.$api.authGoogle(req, (data, meta) => {
                this.loadingGoogle = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                window.location.href = data;
            });
        },
    },
};
</script>

<style scoped></style>
